import { css } from "styled-components";
import { CarouselControls, CarouselSlide, Carousel, CarouselProgressBar, CarouselSlides, } from "../../../../components/Carousel";
import { BladeHeader, BladeHeaderSupertitle, BladeHeaderTitle, BladeHeaderBody, } from "../../../../components/BladeHeader";
export const riotProductSkin = (chroma, paletteTokens) => css `
  --carousel-n-up: 7;
  --carousel-gap: 0px;
  --carousel-gap-count: calc(var(--carousel-n-up) - 1);

  & {
    background-color: ${paletteTokens.bladebg1};
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  }

  .media-viewport {
    background-color: ${paletteTokens.keyline};

    .viewport-inner {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .main-media {
      object-fit: contain;
    }
  }

  ${BladeHeader} {
    ${BladeHeaderSupertitle} {
      ${chroma.typography.body2};
      color: ${paletteTokens.bladetext1};
      font-weight: 500;
      margin-bottom: ${chroma.spacers.variable.xxs};
      text-align: center;
    }

    ${BladeHeaderTitle} > h2 {
      ${chroma.typography.display3};
      color: ${paletteTokens.bladetext1};
      margin-bottom: ${chroma.spacers.variable.sm};
      text-wrap: balance;
      text-align: center;
    }

    ${BladeHeaderBody} {
      ${chroma.typography.body3};
      margin-bottom: ${chroma.spacers.variable.xl};
      text-align: center;
    }
  }

  ${Carousel} {
    margin-top: ${chroma.spacers.constant.s};

    &[data-state-all-slides-visible="true"] {
      ${CarouselControls} {
        display: none;
      }

      .separator {
        display: block;
      }

      ${CarouselSlides} {
        justify-content: center;
      }
    }
  }

  ${CarouselSlides} {
    gap: var(--carousel-gap);
  }

  ${CarouselSlide} {
    cursor: pointer;
    box-sizing: border-box;
    padding: ${chroma.spacers.constant.xxxs};
    border: 1px solid transparent;
    position: relative;

    .thumbnail {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.4;

      &:hover {
        opacity: 1;
      }
    }

    .underlay {
      background-color: ${paletteTokens.bladebg1};
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &[data-slide-active="true"] {
      border-color: ${paletteTokens.accents1};

      .thumbnail {
        opacity: 1;
      }
    }

    ${chroma.mediaQueries.tabletDown} {
      --carousel-n-up: 5;
    }

    ${chroma.mediaQueries.mobileDown} {
      --carousel-n-up: 4;
    }

    --slide-width: calc((100% - (var(--carousel-gap) * (var(--carousel-n-up) - 1))) / var(--carousel-n-up));

    min-width: var(--slide-width);
  }

  ${CarouselControls} {
    margin: ${chroma.spacers.constant.s} 0;
    display: flex;
    gap: ${chroma.spacers.constant.s};
  }

  ${CarouselProgressBar} {
    width: auto;
    flex-grow: 1;
    padding-right: 0;
    align-self: center;

    .indicator {
      transition: width 0.7s ease-out;
      background-color: ${paletteTokens.accents1};
    }

    .rail {
      background-color: ${paletteTokens.keyline};
      margin: 0;
      width: 100%;
    }
  }

  .trigger-wrapper {
    display: flex;
    gap: ${chroma.spacers.constant.xs};
  }

  .media-content {
    .heading {
      ${chroma.typography.body2};
      font-weight: bold;
      color: ${paletteTokens.bladetext1};
    }

    .description {
      ${chroma.typography.body4};
      color: ${paletteTokens.bladetext1};
      text-align: center;
    }

    .separator {
      display: none;
      border: 1px solid ${paletteTokens.keyline};
    }
  }
`;
//# sourceMappingURL=index.js.map